import { IonContent, IonHeader, IonPage, IonToolbar } from "@ionic/react";
import { Typography } from "@mui/joy";
import { useParams } from "react-router";
import ExploreContainer from "../../components/formComponents/ExploreContainer/ExploreContainer";
import HeaderMenu from "../../components/formComponents/Menu/Menu";
import "./Page.css";

import { FC } from "react";

type PageProps = {
  MenuComponent?: FC<any>;
};

const Page: FC<PageProps> = () => {
  const { name } = useParams<{ name: string }>();

  return (
    <>
      <HeaderMenu />
      <IonPage className="portal-page-with-header">
        {/* <IonHeader>
          <IonToolbar>
            <Typography level="title-md">{name.toUpperCase()}</Typography>
          </IonToolbar>
        </IonHeader> */}
        <IonContent fullscreen>
          <IonHeader collapse="condense">
            <IonToolbar>
              <Typography level="title-md">{name.toUpperCase()}</Typography>
            </IonToolbar>
          </IonHeader>
          <ExploreContainer name={name} />
        </IonContent>
      </IonPage>
    </>
  );
};

export default Page;
